// extracted by mini-css-extract-plugin
export default {"wrapper":"Payment_wrapper__IhZ4o","row":"Payment_row__C1AKO","checkbox":"Payment_checkbox__qQI1E","sum":"Payment_sum__XnRpe","control":"Payment_control__1mCu6"};